/*
*
* File JS per la Basic Page
*
*/


// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import cardNews from '../../components/cards/card-news';
import pagination from '../../components/pagination/pagination';
import archiveFilters from '../../components/archive-filters/archive-filters';
import blockNewsMedia from '../../components/block-news-media/block-news-media';
import banner from '../../components/banner/banner';
import bannerWide from '../../components/banner_wide/banner_wide';
import blockVideo from '../../components/block-video/block-video';
import gallery from '../../components/block-gallery/block-gallery';
import blockApp from '../../components/block-app/block-app';
import accordion from '../../components/block-accordion/accordion';
import download_cta from '../../components/block-download-cta/download_cta';
import download_cta__inline from '../../components/block-download-cta-inline/download_cta_inline';
import loghi_societa from '../../components/block_loghi_societa/loghi_societa';
import fasiDiVendita from '../../components/fasi_di_vendita/fasi_di_vendita';
import blockStadio from 'components/block-stadio/block-stadio';
import blockCards from '../../components/block_cards/block_cards';

import blockText from '../../components/block-text/block-text';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//
gallery();
blockStadio();

fasiDiVendita();

//--------------------------------------------------------------------//